import { render, staticRenderFns } from "./CustomReportPage5.vue?vue&type=template&id=76ca2234&scoped=true"
import script from "./CustomReportPage5.vue?vue&type=script&lang=js"
export * from "./CustomReportPage5.vue?vue&type=script&lang=js"
import style0 from "./CustomReportPage5.vue?vue&type=style&index=0&id=76ca2234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ca2234",
  null
  
)

export default component.exports